<template>
  <section id="dashboard">
    <b-row class="match-height">
      <b-col v-if="guidCompany" class="col-12">
        <b-card no-body class="card-statistics">
          <b-card-header>
            <b-card-title>Estadísticas</b-card-title>
          </b-card-header>
          <b-card-body class="statistics-body">
            <b-row>
              <b-card-text v-if="noStatsData" class="text-center w-100 mb-2">
                Sin datos disponibles
              </b-card-text>

              <b-col
                v-if="productsTotal"
                md="4"
                sm="6"
                xl="3"
                class="mb-2 mb-md-0 d-flex align-items-center"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="light-danger">
                      <feather-icon size="24" icon="BoxIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ productsTotal }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("pages.dashboard.productsTotal") }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                v-if="servicesTotal"
                md="4"
                sm="6"
                xl="3"
                class="mb-2 mb-md-0 d-flex align-items-center"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="light-danger">
                      <feather-icon size="24" icon="ToolIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ servicesTotal }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("pages.dashboard.servicesTotal") }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                v-if="customersTotal"
                md="4"
                sm="6"
                xl="3"
                class="mb-2 mb-md-0 d-flex align-items-center"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="light-info">
                      <feather-icon size="24" icon="UserIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ customersTotal }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("pages.dashboard.customersTotal") }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                v-if="ordersTotal"
                md="4"
                sm="6"
                xl="3"
                class="mb-2 mb-md-0 d-flex align-items-center"
              >
                <b-media no-body>
                  <b-media-aside class="mr-2">
                    <b-avatar size="48" variant="light-success">
                      <feather-icon size="24" icon="ShoppingCartIcon" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto">
                    <h4 class="font-weight-bolder mb-0">
                      {{ ordersTotal }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      {{ $t("pages.dashboard.ordersTotal") }}
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col v-if="guidCompany && ordersTotal" class="col-12">
        <b-card no-body class="card-statistics">
          <b-card-header>
            <b-card-title>Ordenes por estados</b-card-title>
          </b-card-header>
          <b-card-body
            class="statistics-body"
            style="padding-top: 0px !important; padding-bottom: 0px !important"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <analytics-support-tracker :data="supportTracker" />
              </b-media-body>
            </b-media>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col v-if="guidCompany" cols="12">
        <SubscriptionCard
          v-if="!!dataMessages.nombreCompania"
          :plan-name="dataMessages.nombreSuscripcion"
          :expires-at="dataMessages.vigenteHasta"
          :price="dataMessages.amount"
          :messages-consumed="dataMessages.mensajesConsumidos"
          :messages-paid="dataMessages.mensajesPagados"
          :messages-remaining="dataMessages.mensajesRestantes"
          :type-payment="dataMessages.tipoPago"
        />
      </b-col>

      <b-col v-if="guidCompany" cols="12">
        <b-card no-body class="card-revenue-budget">
          <b-row class="mx-0">
            <b-col md="12" class="revenue-report-wrapper">
              <div
                class="d-sm-flex justify-content-between align-items-center mb-3"
              >
                <h4 class="card-title mb-50 mb-sm-0">
                  {{ $t("pages.dashboard.conversationsByMonth") }}
                </h4>
                <div class="d-flex align-items-center">
                  <b-dropdown
                    :text="currentYear"
                    size="sm"
                    class="budget-dropdown"
                    variant="outline-primary"
                  >
                    <b-dropdown-item
                      @click="changeConversations(year)"
                      v-for="year in arrayYears"
                      :key="year"
                    >
                      {{ year }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <vue-apex-charts
                id="revenue-report-chart"
                :key="conversationsChartKey"
                type="bar"
                height="230"
                :options="revenueReport.chartOptions"
                :series="series"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col v-if="guidCompany" cols="12">
        <b-card no-body class="card-revenue-budget">
          <b-row class="mx-0">
            <b-col md="12" class="revenue-report-wrapper">
              <div
                class="d-sm-flex justify-content-between align-items-center mb-3"
              >
                <h4 class="card-title mb-50 mb-sm-0">
                  {{ $t("pages.dashboard.salesByMonth") }}
                </h4>
                <div class="d-flex align-items-center">
                  <b-dropdown
                    :text="currentYearOrder"
                    size="sm"
                    class="budget-dropdown"
                    variant="outline-primary"
                  >
                    <b-dropdown-item
                      @click="changeOrdersByMonth(year)"
                      v-for="year in arrayYears"
                      :key="year"
                    >
                      {{ year }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>

              <vue-apex-charts
                id="appointments-report-chart"
                type="bar"
                :key="appointmentsChartKey"
                height="350"
                :options="appointmentsReport"
                :series="appointmentsSeries"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col v-if="guidCompany" cols="12" md="6">
        <b-card>
          <b-alert :variant="botStatus ? 'success' : 'danger'" show>
            <div class="alert-body">
              <span
                ><strong>Alerta!</strong> <br />
                Esta opción te permite habilitar o inhabilitar el asistente
                virtual.</span
              >
            </div>
          </b-alert>
          <b-form-checkbox
            id="botStatus"
            v-model="statusBot"
            switch
            inline
            @input.native="changeSatus($event)"
          >
            {{ isStatus(statusBot) }}
          </b-form-checkbox>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormCheckbox,
  BBadge,
  BAlert,
  BTable,
  BFormGroup,
  BImg,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import SubscriptionCard from "./SubscriptionCard.vue";
import { $themeColors } from "@themeConfig";
import Ripple from "vue-ripple-directive";
import {
  dashboardDetails,
  conversatitonByMonth,
  salesByMonth,
  getTotalMessages,
} from "@core/api/request/dashboard";
import AnalyticsSupportTracker from "./AnalyticsSupportTracker.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { startBot, stopBot } from "@core/api/request/azureArquitecture";
import { showLoading, stopLoading } from "@core/utils/utils";
import * as moment from "moment";
import "moment/locale/es";
import "moment-timezone";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BImg,
    BMediaAside,
    BMediaBody,
    VueApexCharts,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormCheckbox,
    SvgIcon,
    BBadge,
    BAlert,
    BTable,
    BFormGroup,
    SubscriptionCard,
    AnalyticsSupportTracker,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      arrayYears: [],
      ordersCompany: [],
      currentYear: new Date().getFullYear().toString(),
      currentYearOrder: new Date().getFullYear().toString(),
      conversationsChartKey: 0,
      appointmentsChartKey: 0,
      conversationsOrderChartKey: 0,
      productsTotal: 0,
      servicesTotal: 0,
      customersTotal: 0,
      ordersTotal: 0,

      botStatus: false,
      // userData: {},
      // companyGuid: "",
      dataMessages: {
        nombreCompania: "",
        nombreSuscripcion: "",
        mensajesPagados: 0,
        mensajesConsumidos: 0,
        mensajesRestantes: 0,
        startDate: "",
        vigenteHasta: "",
        fechaPago: "",
        amount: 0,
        tipoPago: "",
        referenceNumber: "",
      },

      supportTracker: {
        totalOrders: 0,
        generated: 0,
        attended: 0,
        processed: 0,
        finished: 0,
        rejected: 0,
        supportTrackerRadialBar: {
          series: [0],
        },
      },

      series: [
        {
          name: "Total",
          data: [],
        },
      ],
      appointmentsSeries: (() => {
        const zeroes = Array(12).fill(0);
        return [
          { name: "Total citas", data: [...zeroes] },
          { name: "Programadas", data: [...zeroes] },
          { name: "Confirmadas", data: [...zeroes] },
          { name: "Completadas", data: [...zeroes] },
          { name: "Canceladas", data: [...zeroes] },
        ];
      })(),

      ordersSeries: [
        {
          name: "Total",
          data: [],
        },
      ],
      ordersChart: {
        series: [0, 0, 0, 0, 0],
        chartOptions: {
          chart: {
            type: "donut",
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          labels: [
            this.$t("pages.dashboard.generated"),
            this.$t("pages.dashboard.attended"),
            this.$t("pages.dashboard.processed"),
            this.$t("pages.dashboard.finished"),
            this.$t("pages.dashboard.canceled"),
          ],
          stroke: { width: 0 },
          colors: [
            $themeColors.warning,
            "#0172ff",
            "#44b8ff",
            $themeColors.success,
            $themeColors.danger,
          ],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`;
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: this.$t("pages.dashboard.orders"),
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },
      revenueReport: {
        chartOptions: {
          chart: {
            stacked: true,
            type: "bar",
            toolbar: { show: false },
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
            },
            yaxis: {
              lines: { show: true },
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: "#6E6B7B",
                fontSize: "0.86rem",
                fontFamily: "Montserrat",
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.primary, $themeColors.warning],
          plotOptions: {
            bar: {
              columnWidth: "80%",
              // endingShape: "rounded",
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              style: {
                colors: "#6E6B7B",
                fontSize: "0.86rem",
                fontFamily: "Montserrat",
              },
            },
          },
        },
      },
      appointmentsReport: {
        chart: {
          height: 350,
          type: "bar",
          stacked: false,
          zoom: { enabled: false },
          toolbar: { show: false },
          fontFamily: "Montserrat",
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 0,
            dataLabels: {
              position: "top",
            },
          },
        },

        dataLabels: {
          enabled: false,
        },

        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
          yaxis: {
            lines: { show: true },
          },
        },

        xaxis: {
          categories: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
          ],
          axisTicks: { show: false },
          axisBorder: { show: false },
          crosshairs: {
            show: true,
            width: 1,
            position: "back",
            opacity: 0.2,
          },
          accessibility: {
            description: "Meses",
          },
          labels: {
            style: {
              colors: "#6E6B7B",
              fontSize: "0.86rem",
              fontFamily: "Montserrat",
            },
          },
        },

        yaxis: {
          min: 0,
          title: {
            text: "Cantidad de citas",
            style: {
              color: "#6E6B7B",
              fontSize: "0.86rem",
              fontFamily: "Montserrat",
            },
          },
          labels: {
            style: {
              colors: "#6E6B7B",
              fontSize: "0.86rem",
              fontFamily: "Montserrat",
            },
          },
        },

        tooltip: {
          y: {
            formatter: (val) => `${val} (citas)`,
          },
        },

        legend: {
          show: true,
          position: "bottom",
        },

        colors: [
          "#3B82F6", // TotalAppointments
          "#F59E0B", // Programadas
          "#10B981", // Confirmadas
          "#EF4444", // Canceladas
          "#8B5CF6", // Completadas
        ],
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.appConfig.user;
    },

    guidCompany() {
      const appConfig = this.$store.state.appConfig;
      const session = this.$store.state.appConfig.sessionContext;

      if (!session) return null;

      if (appConfig.role === "BACKOFFICE") {
        return appConfig.activeCompanyGuid;
      }

      return (
        appConfig.activeCompanyGuid ||
        session.activeCompanyGuid ||
        session.idCompany
      );
    },

    noStatsData() {
      return (
        this.productsTotal === 0 &&
        this.servicesTotal === 0 &&
        this.customersTotal === 0 &&
        this.ordersTotal === 0
      );
    },

    statusBot: {
      // get() {
      //   if (this.guidCompany) {
      //     return this.$store.state.appConfig.bot;
      //   } else {
      //     return false;
      //   }
      // },
      get() {
        return this.guidCompany ? this.$store.state.appConfig.bot : false;
      },
      set(value) {
        this.$store.commit("appConfig/SET_BOT", value);
      },
    },
  },

  watch: {
    // "$store.state.appConfig.guidCompany"(guid) {
    //   this.companyGuid = guid;
    // },

    // guidCompany: {
    //   handler(newValue, oldValue) {
    //     if (this.companyGuid !== null && this.companyGuid !== "") {
    //       // this.getAssitentMessages(this.companyGuid);
    //       if (this.companyGuid) {
    //         this.getAssitentMessages(this.companyGuid);
    //       }
    //       this.changeConversations(this.currentYear);
    //       this.changeOrdersByMonth(this.currentYearOrder);
    //       this.loadDetails(this.companyGuid);
    //     }
    //   },
    //   immediate: true, // Se ejecuta inmediatamente al montar el componente
    // },

    guidCompany: {
      immediate: true,
      handler(guid) {
        this.resetDashboardData();

        if (!guid) return;

        this.getAssitentMessages(guid);
        this.changeConversations(this.currentYear, guid);
        this.changeOrdersByMonth(this.currentYearOrder, guid);
        this.loadDetails(guid);
      },
    },
  },

  created() {
    // this.userData = this.$store.state.appConfig.user;
  },

  mounted() {
    // this.companyGuid = this.$store.state.appConfig.guidCompany;
    // if (this.companyGuid !== null && this.companyGuid !== "") {
    //   this.getAssitentMessages(this.companyGuid);
    //   this.changeOrdersByMonth(this.currentYearOrder);
    //   this.loadDetails(this.companyGuid);
    // }
    this.currentYear = new Date().getFullYear().toString();
    this.arrayYears = [];
    for (let i = 0; i <= 5; i++) {
      this.arrayYears.push(parseInt(this.currentYear) - i);
    }
    // this.changeConversations(this.currentYear);
  },

  methods: {
    isStatus(value) {
      return value ? "Activo" : "Inactivo";
    },

    changeSatus(e) {
      e.stopPropagation();
      e.preventDefault();
      const Status = !this.$store.state.appConfig.bot;
      this.$swal({
        title: "Estas seguro(a)?",
        target: "body",
        inputLabel: `Escribe ${this.currentUser.Name} para confirmar`,
        input: "text",
        inputPlaceholder: `${this.currentUser.Name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, cambiar estado!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        inputValidator: (value) =>
          new Promise((resolve) => {
            const stringValue = this.currentUser.Name;
            if (value === stringValue) {
              resolve();
            } else {
              resolve(`Tu necesita escribir ${this.currentUser.Name}`);
            }
          }),
      }).then((result) => {
        if (result.isConfirmed) {
          const action = Status ? startBot : stopBot;

          action(this.guidCompany)
            .then((resp) => {
              this.$store.commit("appConfig/SET_BOT", Status);
              this.$swal.close();
            })
            .catch((error) => {
              this.statusBot = !Status;
              this.$swal.close();
              this.alertToast("danger", "Alerta error", error);
            });
        } else {
          this.statusBot = !Status;
          this.$swal.close();
        }
      });
    },

    showOrderIcon(status) {
      switch (status) {
        case "Generada":
          return "WatchIcon";
        case "Atendida":
          return "PhoneCallIcon";
        case "Procesada":
          return "CheckCircleIcon";
        case "Terminada":
          return "TrendingUpIcon";
        case "Rechazada":
          return "TrendingDownIcon";
        default:
          return "HelpCircleIcon";
      }
    },

    showOrderColor(status) {
      switch (status) {
        case "Generada":
          return "light-warning";
        case "Atendida":
          return "light-primary";
        case "Procesada":
          return "light-info";
        case "Terminada":
          return "light-success";
        case "Rechazada":
          return "light-danger";
        default:
          return "light-secondary";
      }
    },

    async changeConversations(year, guidCompany = this.guidCompany) {
      if (!guidCompany) return;
      this.currentYear = year.toString();
      let conversationsResponse = await conversatitonByMonth(guidCompany, year);
      if (guidCompany !== this.guidCompany) return;

      if (!conversationsResponse.err) {
        let conversationSeries = conversationsResponse.data.map((element) => {
          return element.TotalConversations;
        });

        let categoriesChart = conversationsResponse.data.map((element) => {
          return element.MonthName.substring(0, 3);
        });

        // Actualizar las categorías
        this.revenueReport.chartOptions.xaxis.categories = categoriesChart;

        // Forzar re-render del gráfico incrementando la key
        this.conversationsChartKey++;

        this.series = [
          {
            name: "Total",
            data: conversationSeries,
          },
        ];
      }
    },

    async changeOrdersByMonth(year, guidCompany = this.guidCompany) {
      if (!guidCompany) return;
      this.currentYearOrder = year.toString();
      let ordersResponse = await salesByMonth(guidCompany, year);
      if (guidCompany !== this.guidCompany) return;

      if (!ordersResponse.err) {
        const categoriesOrderChart = ordersResponse.data.map((element) =>
          element.MonthName.substring(0, 3),
        );

        this.appointmentsReport.xaxis.categories = categoriesOrderChart;
        this.appointmentsChartKey += 1;

        this.appointmentsSeries = [
          {
            name: "Total citas",
            data: ordersResponse.data.map((m) => m.TotalAppointments || 0),
          },
          {
            name: "Programadas",
            data: ordersResponse.data.map((m) => m.AppProgramadas || 0),
          },
          {
            name: "Confirmadas",
            data: ordersResponse.data.map((m) => m.AppConfirmadas || 0),
          },
          {
            name: "Completadas",
            data: ordersResponse.data.map((m) => m.AppCompletadas || 0),
          },
          {
            name: "Canceladas",
            data: ordersResponse.data.map((m) => m.AppCanceladas || 0),
          },
        ];
      }
    },

    async loadDetails(guid) {
      if (!guid) return;
      showLoading();
      await dashboardDetails(guid)
        .then((resp) => {
          if (guid !== this.guidCompany) return;

          const data = _.get(resp, "data");
          if (resp.err) {
            this.alertToast("danger", `Alerta`, data.message);
            return;
          }

          this.customersTotal = data.TotalClients;
          this.ordersTotal = data.TotalOrders;
          this.productsTotal = data.TotalProductStock;
          this.servicesTotal = data.TotalServiceStock;
          this.ordersCompany = data.Ordenes;
          if (Array.isArray(data.Ordenes) && data.Ordenes.length) {
            const statusKeyMap = {
              Generada: "generated",
              Atendida: "attended",
              Procesada: "processed",
              Terminada: "finished",
              Rechazada: "rejected",
            };

            const counts = {
              generated: 0,
              attended: 0,
              processed: 0,
              finished: 0,
              rejected: 0,
            };

            data.Ordenes.forEach((el) => {
              const key = statusKeyMap[el.Status];
              const val = Number(el.TotalOrders) || 0;
              if (key) counts[key] = val;
            });

            this.ordersSeries = [
              counts.generated,
              counts.attended,
              counts.processed,
              counts.finished,
              counts.rejected,
            ];

            const completedOrders = data.TotalOrders
              ? Math.round((counts.finished / Number(data.TotalOrders)) * 100)
              : 0;

            Object.assign(this.supportTracker, {
              totalOrders: data.TotalOrders || 0,
              generated: counts.generated,
              attended: counts.attended,
              processed: counts.processed,
              finished: counts.finished,
              rejected: counts.rejected,
              supportTrackerRadialBar: {
                series: [completedOrders],
              },
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        })
        .finally(() => {
          stopLoading();
        });
    },
    async getAssitentMessages(guidCompany) {
      if (!guidCompany) return;
      await showLoading();
      let response = await getTotalMessages(guidCompany);
      stopLoading();
      if (guidCompany !== this.guidCompany) return;

      if (!response.err) {
        this.dataMessages = response.data;
      }
    },

    resetDashboardData() {
      this.productsTotal = 0;
      this.servicesTotal = 0;
      this.customersTotal = 0;
      this.ordersTotal = 0;
      this.ordersCompany = [];
      this.dataMessages = {
        nombreCompania: "",
        nombreSuscripcion: "",
        mensajesPagados: 0,
        mensajesConsumidos: 0,
        mensajesRestantes: 0,
        startDate: "",
        vigenteHasta: "",
        fechaPago: "",
        amount: 0,
        tipoPago: "",
        referenceNumber: "",
      };
      this.supportTracker = {
        totalOrders: 0,
        generated: 0,
        attended: 0,
        processed: 0,
        finished: 0,
        rejected: 0,
        supportTrackerRadialBar: {
          series: [0],
        },
      };
      this.series = [
        {
          name: "Total",
          data: [],
        },
      ];
      this.revenueReport.chartOptions.xaxis.categories = [];
      this.appointmentsSeries = [
        { name: "Total citas", data: Array(12).fill(0) },
        { name: "Programadas", data: Array(12).fill(0) },
        { name: "Confirmadas", data: Array(12).fill(0) },
        { name: "Completadas", data: Array(12).fill(0) },
        { name: "Canceladas", data: Array(12).fill(0) },
      ];
      this.appointmentsChartKey += 1;
      this.conversationsChartKey += 1;
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(amount);
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    label(field) {
      return `pages.dashboard.table.${field}`;
    },
    labelHeader(field) {
      return `pages.dashboard.table.tableHeader.${field}`;
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/dashboard-ecommerce.scss";
</style>
<style lang="scss">
.kpi-container {
  background: white;

  .icon-container {
    background: #0172ff;
    display: inline-block;
    border-radius: 100%;
    padding: 20px;
  }
}

.kpi-text-container {
  background: #0172ff;
  height: 100%;
}

.kpis-col {
  .card-body {
    padding: 0;
    overflow: hidden;
    border-radius: inherit;
  }
}

.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
